import React, {Component} from 'react';
import { connect } from "react-redux";
import { Field, reduxForm, formValueSelector } from "redux-form";
import {
    renderField,
    renderCheckbox,
    required,
    renderTextArea,
    json,
    positive_float
} from "../../../utils/formValidations.js";
import { withRouter } from "react-router-dom";
import { Form, FormGroup, Button, Label, Row, Col, CardBody, CardFooter, Collapse, Alert } from "reactstrap";
import Proptypes from "prop-types";
import { NotificationManager } from "react-notifications";
import {getConnectionProxies } from "../../../actions/actionConnectionProxies";
import {getZones} from "../../../actions/actionZones";
import SelectInput from "../../../components/SelectInput";

class ConnectionProxyFormTemplate extends Component {
    constructor (props){
        super(props);
        this.state = {
            currentConnectionProxy: {},
            collapseAdvanced: false,
        };
        this.submitApi = this.submitApi.bind(this);
        this.handleCreateSuccess = this.handleCreateSuccess.bind(this);
        this.handleCreateError = this.handleCreateError.bind(this);
        this.handleUpdateError = this.handleUpdateError.bind(this);
        this.handleUpdateSuccess = this.handleUpdateSuccess.bind(this);
    }

    submitApi(userData) {
        if (this.props.fromUpdate) {
            userData.connection_proxy_id = this.state.currentConnectionProxy && this.state.currentConnectionProxy.connection_proxy_id;
            this.props.updateConnectionProxy(userData)
                .then(() => this.handleUpdateSuccess())
                .catch(() => this.handleUpdateError());
        }else {
            this.props.createConnectionProxy(userData)
                .then(() => this.handleCreateSuccess())
                .catch(() => this.handleCreateError());
        }
    }

    handleUpdateSuccess(){
        const {updateConnectionProxyError} = this.props;
        if(updateConnectionProxyError){
            NotificationManager.error(updateConnectionProxyError,"Update Connection Proxy Config", 3000);
        }
        else{
            NotificationManager.success("Connection Proxy Config Updated", "Successfully Updated Connection Proxy Config");
            this.props.history.push("/connection_proxies");
        }
    }

    handleUpdateError(){
        const {updateConnectionProxyError} = this.props;
        if(updateConnectionProxyError){
            NotificationManager.error(updateConnectionProxyError,"Update Connection Proxy Config", 3000);
        } else
            NotificationManager.error("Update Connection Proxy Config Failed", "Update ConnectionProxy Config", 3000);
    }

    handleCreateSuccess(){
        const {createConnectionProxyError} = this.props;
        if(createConnectionProxyError){
            NotificationManager.error(createConnectionProxyError,"Create Connection Proxy Config", 3000);
        }
        else{
            NotificationManager.success("Connection Proxy Config Created", "Successfully Created Connection Proxy Config");
            this.props.history.push("/connection_proxies");
        }
    }

    handleCreateError(){
        const {createConnectionProxyError} = this.props;
        if(createConnectionProxyError){
            NotificationManager.error(createConnectionProxyError,"Create Connection Proxy Config", 3000);
        } else
            NotificationManager.error("Create Connection Proxy Config Failed","Create Connection Proxy Config", 3000);
    }

    cancelButton(){
        this.props.history.push("/connections_proxies");
    }


    UNSAFE_componentWillReceiveProps(nextProps){
        if(nextProps.connection_proxies && nextProps.connection_proxies.length > 0 && this.props.connection_proxies !== nextProps.connection_proxies && this.props.getConnectionProxiesLoading && this.props.fromUpdate){
            let currentConnectionProxy = nextProps.connection_proxies.find(connection_proxy => connection_proxy.connection_proxy_id === this.props.connectionProxyId);
            this.setState({currentConnectionProxy: currentConnectionProxy});
            this.props.initialize({
                connection_proxy_type: currentConnectionProxy.connection_proxy_type,
                auth_token: currentConnectionProxy.auth_token,
                server_address: currentConnectionProxy.server_address,
                server_port: currentConnectionProxy.server_port,
                zone_id: currentConnectionProxy.zone_id,
            });
        }
    }

    componentDidMount() {
        this.props.getZones();
        if (this.props.fromUpdate) {
            this.props.getConnectionProxies();
        }
    }
    

    render() {
        const {handleSubmit, zones, connectionProxyFormValues} = this.props;
        const deny_by_default_checked = false;
        let optionsZones = [];
        zones.map(opt => {
            optionsZones.push({label: opt.zone_name, value: opt.zone_id});
        });

        let optionsConnectionTypes=[
            {value:'RDP', label:'RDP'}
        ]
        return (
            <Form onSubmit={handleSubmit(this.submitApi)}>
                <CardBody>
                    <FormGroup>
                        <Row>
                            <Col>
                                <Label htmlFor="name" className="requiredasterisk">Server Address </Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="text"
                                       name="server_address"
                                       id="server_address"
                                       component={renderField}
                                       validate={required}
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col>
                                <Label htmlFor="server_port" className="requiredasterisk">Server Port </Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="number"
                                       name="server_port"
                                       id="server_port"
                                       component={renderField}
                                       validate={[required, positive_float]}
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col>
                                <Label htmlFor="connection_proxy_type" className="requiredasterisk">Connection Type </Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field name="connection_proxy_type"
                                       selectedValue={connectionProxyFormValues && connectionProxyFormValues.connection_proxy_type ? connectionProxyFormValues.connection_proxy_type: ""}
                                       options={optionsConnectionTypes}
                                       validate={required}
                                       isUpdateForm={this.props.fromUpdate}
                                       component={SelectInput}
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col>
                                <Label htmlFor="connection_proxy_type" className="requiredasterisk">Authentication Token </Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="text"
                                       name="auth_token"
                                       id="auth_token"
                                       component={renderField}
                                       validate={required}
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col>
                                <Label htmlFor="zone" className="requiredasterisk">Zone </Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field name="zone_id"
                                       selectedValue={connectionProxyFormValues && connectionProxyFormValues.zone_id ? connectionProxyFormValues.zone_id: ""}
                                       options={optionsZones}
                                       validate={required}
                                       isUpdateForm={this.props.fromUpdate}
                                       component={SelectInput}
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                </CardBody>
                <CardFooter>
                    <FormGroup className="form-actions">
                        <Button type="cancel" size="sm" 
                        className="cancel-button"
                        color="basic" onClick={() => this.cancelButton()}>Cancel</Button>
                        <Button type="submit"
                        className="submit-button"
                        size="sm" color="primary">Submit</Button>
                    </FormGroup>
                </CardFooter>
            </Form>
        );
    }
}

ConnectionProxyFormTemplate.proptypes = {
    createConnectionProxy: Proptypes.func,
    updateConnectionProxy: Proptypes.func,
    fromUpdate: Proptypes.bool,
};

let ConnectionProxyFormWithRouter = withRouter(ConnectionProxyFormTemplate);


const selector = formValueSelector('ConnectionProxyForm');

let ConnectionProxyForm =  connect(state =>{


            return {
                createConnectionProxyError: state.connection_proxies.createConnectionProxyError,
                createConnectionProxyLoading: state.connection_proxies.createConnectionProxyLoading,
                createdConnectionProxy: state.connection_proxies.createdConnectionProxy,
                updateConnectionProxyError: state.connection_proxies.updateConnectionProxyError,
                updateConnectionProxyLoading: state.connection_proxies.updateConnectionProxyLoading,
                updatedConnectionProxy: state.connection_proxies.updatedConnectionProxy,
                connection_proxies: state.connection_proxies.connection_proxies,
                getConnectionProxiesLoading: state.connection_proxies.getConnectionProxiesLoading || false,
                connectionProxyFormValues: state.form && state.form.ConnectionProxyForm && state.form.ConnectionProxyForm.values ? state.form.ConnectionProxyForm.values : null,
                zones: state.zones.zones || [],
            }
    },

    dispatch =>
        ({
            getConnectionProxies: () => dispatch(getConnectionProxies()),
            getZones: () => dispatch(getZones()),
        }))(ConnectionProxyFormWithRouter);

export default reduxForm({
    form: "ConnectionProxyForm",
})(ConnectionProxyForm);